<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-type"
  [activeStep]="0"
  [sectionTitle]="'activity_creation.type.section.title' | translate"
  [sectionDescription]="
    'activity_creation.type.section.description' | translate
  "
  [error$]="error$"
  [formGroup]="formGroup"
  (formSubmit)="submit($event)"
>
  <fieldset>
    <legend class="sr-only">
      {{ 'activity_creation.type.form.legend' | translate }}
    </legend>

    <app-form-control [errorMessages]="errorMessages('type')">
      <app-form-radio-button
        *ngFor="let type of types"
        #controlChild
        [label]="type.label"
        [htmlValue]="type.htmlValue"
        required="true"
        formControlName="type"
        name="type"
      ></app-form-radio-button>
    </app-form-control>
  </fieldset>
</app-organizer-shared-form-wrapper>
